import React, { useEffect, useState } from "react";
import { makeRequest2 } from "../../../utils/makeRequest";
import { toastify } from "../../../utils/toast";
import { getItem } from "../../../utils/localStorage";
import {
    addDocumentTypeURL,
    getDocumentTypesURL,
} from "../../../utils/urls";

const DocumentType = () => {
    const [documentTypes, setDocumentTypes] = useState([]);
    const [name, setName] = useState("");
    const [loading, setLoading] = useState(false);

    // ✅ Fetch all document types
    const fetchDocumentTypes = async () => {
        try {
            const facilityId = await getItem("selectedFacilityId");
            const response = await makeRequest2(
                `${getDocumentTypesURL}/${facilityId}`,
                "GET"
            );

            if (response.success) {
                const dataArray =
                    response.data?.data && Array.isArray(response.data.data)
                        ? response.data.data
                        : Array.isArray(response.data)
                            ? response.data
                            : [];

                setDocumentTypes(dataArray);
            } else {
                toastify(response.error || "Failed to load document types", "error");
            }
        } catch (err) {
            toastify(err.message, "error");
        }
    };

    // ✅ Add new document type
    const handleAddDocumentType = async (e) => {
        e.preventDefault();

        if (!name.trim()) {
            return toastify("Please enter a document type name.", "error");
        }

        try {
            setLoading(true);
            const facilityId = await getItem("selectedFacilityId");

            const response = await makeRequest2(
                `${addDocumentTypeURL}/${facilityId}`,
                "POST",
                { name: name.trim() }
            );

            if (response.success) {
                toastify(response.message, "success");
                setName("");
                fetchDocumentTypes(); // Refresh list
            } else {
                toastify(response.error || "Failed to add document type", "error");
            }
        } catch (err) {
            toastify(err.message, "error");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDocumentTypes();
    }, []);

    return (
        <div className="row p-3">
            {/* ➕ Add Document Type Section */}
            <div className="col-lg-6">
                <div className="card shadow-sm">
                    <div className="card-body">
                        <h5 className="card-title mb-3">
                            <i className="ti ti-file-plus me-2 text-primary"></i>
                            Add Document Type
                        </h5>

                        <form onSubmit={handleAddDocumentType}>
                            <div className="mb-3">
                                <label className="form-label">Document Type Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="e.g., Lease Agreement"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    maxLength={100}
                                />
                                <small className="text-muted">
                                    Enter a unique name for the document type
                                </small>
                            </div>

                            <div className="text-end mt-4">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading || !name.trim()}
                                >
                                    {loading ? "Adding..." : "Add Document Type"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* 📄 Existing Document Types Section */}
            <div className="col-lg-6">
                <div className="card shadow-sm">
                    <div className="card-body">
                        <h5 className="card-title mb-4">
                            <i className="ti ti-file-description me-2 text-primary"></i>
                            Current Document Types
                        </h5>

                        <div className="table-responsive">
                            <table className="table align-middle">
                                <thead>
                                    <tr>
                                        <th scope="col">DOCUMENT TYPE</th>
                                        <th scope="col">CREATED</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {documentTypes.length > 0 ? (
                                        documentTypes.map((doc) => (
                                            <tr key={doc._id}>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <i
                                                            className="ti ti-file-text text-primary me-2"
                                                            style={{ fontSize: "18px" }}
                                                        ></i>
                                                        <strong>{doc.name}</strong>
                                                    </div>
                                                </td>
                                                <td>
                                                    {doc.createdAt
                                                        ? new Date(doc.createdAt).toLocaleDateString()
                                                        : "N/A"}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="2" className="text-center py-4">
                                                <div className="text-muted">
                                                    <i
                                                        className="ti ti-file-alert mb-2"
                                                        style={{ fontSize: "24px" }}
                                                    ></i>
                                                    <p className="mb-0">No document types available</p>
                                                    <small>
                                                        Add your first document type to get started
                                                    </small>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentType;
